import { httpApi } from '@api/http.api.ts';
import type { AxiosResponse } from 'axios';

export const getApiCertificatePdfData = (resultId: number): Promise<AxiosResponse<Blob>> =>
    httpApi
        .get(`users/results/certificate-pdf/${resultId}`, {
            responseType: 'blob',
        })
        .then((data) => data);
